export default "__VITE_ASSET__78985986__"